import { useQuery } from '@tanstack/react-query';
import { fetchPublicAvatars } from '../../services';

export const useGetPublicAvatarData = () => {
  return useQuery(['fetchPublicAvatars'], fetchPublicAvatars);
};
